import React, { useEffect } from 'react';
import { Brand } from '../../types/data';
import { useTranslation } from 'react-i18next';

interface Props {
  brands: Brand[];
  selectedBrand: string;
  onSelect: (brandId: string) => void;
}

export const BrandSelector: React.FC<Props> = ({ brands, selectedBrand, onSelect }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (brands && brands.length > 0 && !selectedBrand) {
      onSelect(brands[0].id.toString());
    }
  }, [brands, selectedBrand, onSelect]);

  return (
    <>
      <label htmlFor="brand-select" className="block text-sm font-medium mb-2">
        {t('product.select_brand')}
      </label>
      <select
        id="brand-select"
        value={selectedBrand}
        onChange={(e) => onSelect(e.target.value)}
        className="w-full p-2 border rounded-md"
      >
        <option value="">{t('product.select_brand')}</option>
        {brands.map((brand) => (
          <option key={brand.id} value={brand.id}>
            {brand.name}
          </option>
        ))}
      </select>
      {(!brands || brands.length === 0) && (
        <div className="mt-2 text-red-600 text-sm">{t('brands.no_brands_available')}</div>
      )}
    </>
  );
};
